export default __webpack_public_path__ + "static/media/bannerImg.408f2448.png";